import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import { Info, LucideAngularModule, PanelLeftClose, PanelLeftOpen, X } from 'lucide-angular';

import {
  NbActionsModule,
  NbLayoutModule,
  NbSearchModule,
  NbSidebarModule,
  NbUserModule,
  NbContextMenuModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbThemeModule,
  NbMenuModule,
  NbTooltipModule,
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NbSecurityModule } from '@nebular/security';
import {
  BrandLogoModule,
  FooterComponent,
  HeaderComponent,
  SearchInputComponent,
  TinyMCEComponent
} from './components';
import {
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
} from './pipes';
import {
  OneColumnLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
  // MobileColumnComponent
} from './layouts';
import { DEFAULT_THEME } from './styles/theme.default';
import { COSMIC_THEME } from './styles/theme.cosmic';
import { CORPORATE_THEME } from './styles/theme.corporate';
import { DARK_THEME } from './styles/theme.dark';
import { LISTSET_THEME } from './styles/theme.listSet';
import { OptionsMenuComponent } from './components/option-menu/option-menu.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { SearchBoxModule } from './components/search-box/search-box.module';
import { SharedUiModule } from '../shared-modules/ui/ui.module';
import { EllipsisCellComponent } from './components/ellipsis-cell/ellipsis-cell.component';
// import { ReportTableV3Component } from './components/report-table-v3/report-table-v3.component';
// import { ReportTableV2Component } from './components/report-table-v2/report-table-v2.component';
const NB_MODULES = [
  NbLayoutModule,
  NbMenuModule,
  NbUserModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbContextMenuModule,
  NbSecurityModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbEvaIconsModule,
  NbTooltipModule,
];
const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  SearchInputComponent,
  TinyMCEComponent,
  OneColumnLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
  OptionsMenuComponent,
  SearchBarComponent,
  // MobileColumnComponent
];
const PIPES = [
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
];

// import { ModuleRegistry } from 'ag-grid-community'; 
// Register all Community features
// ModuleRegistry.registerModules([AllCommunityModule]);


@NgModule({
  imports: [
    CommonModule, ...NB_MODULES, AgGridAngular, BrandLogoModule, SearchBoxModule, SharedUiModule,
    LucideAngularModule.pick({ PanelLeftClose, PanelLeftOpen, Info, X }),
  ],
  exports: [CommonModule, ...PIPES, ...COMPONENTS, BrandLogoModule, SearchBoxModule],

  // @ts-ignore
  declarations: [...COMPONENTS, ...PIPES, SearchBarComponent, EllipsisCellComponent] // MobileColumnComponent ],
})
export class ThemeModule {
  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        ...NbThemeModule.forRoot(
          {
            name: 'listSet',
          },
          [LISTSET_THEME],
        ).providers,
      ],
    };
  }
}
